import React, { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

import BackToTop from "../../components/BackToTop";
import Contact from "../../components/Contact";
import Footer from "../../Layout/Footer";
import FooterAlt from "../../Layout/FooterAlt";
import NavBar from "../../Layout/Navbar";
import { getServiceBySlug } from "../../data/services";

const DetailCards = ({ title, items }) => (
  <div className="service-detail-group">
    <h2>{title}</h2>
    <Row className="g-4">
      {items.map((item) => (
        <Col lg={4} md={6} key={item.title}>
          <div className="service-detail-card">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        </Col>
      ))}
    </Row>
  </div>
);

const DetailList = ({ title, items }) => (
  <div className="service-detail-list">
    <h2>{title}</h2>
    <ul>
      {items.map((item) => (
        <li key={item}>
          <i className="mdi mdi-check-circle-outline"></i>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </div>
);

const ServiceDetail = () => {
  const { serviceSlug } = useParams();
  const service = getServiceBySlug(serviceSlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceSlug]);

  if (!service) {
    return <Navigate to="/#services" replace />;
  }

  return (
    <React.Fragment>
      <NavBar isDark={true} />
      <main className="service-detail-page">
        <section
          className={
            service.isCampaign
              ? "section service-detail-hero service-detail-hero-campaign"
              : "section service-detail-hero"
          }
        >
          <Container>
            <Row className="align-items-center g-5">
              <Col lg={7}>
                <Link to="/#services" className="service-detail-back">
                  Services
                </Link>
                <h1>{service.title}</h1>
                <p className="service-detail-intro">{service.overview}</p>
                <div className="service-detail-actions">
                  <a href="#service-contact" className="btn btn-primary">
                    {service.contact.submitLabel}
                  </a>
                  <Link to="/#services" className="btn btn-outline-dark">
                    View All Services
                  </Link>
                </div>
              </Col>
              <Col lg={5}>
                <div className="service-detail-snapshot">
                  <img src={service.imgsrc} alt="" className="img-fluid" />
                  <h2>How Citra Helps</h2>
                  <p>{service.caption}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section bg-light service-detail-content">
          <Container>
            {service.campaignCallout && (
              <Row className="justify-content-center">
                <Col lg={10}>
                  <div className="service-campaign-callout">
                    <div>
                      <p className="text-uppercase text-muted mb-2">
                        Support Service
                      </p>
                      <h2>{service.campaignCallout.title}</h2>
                      <p>{service.campaignCallout.description}</p>
                    </div>
                    <a href="#service-contact" className="btn btn-primary">
                      Book The Assessment
                    </a>
                  </div>
                </Col>
              </Row>
            )}

            <DetailCards title="Where We Help" items={service.highlights} />

            <Row className="g-4 service-detail-bottom">
              <Col lg={6}>
                <DetailList title="Outcomes" items={service.outcomes} />
              </Col>
              <Col lg={6}>
                <DetailList
                  title="Typical Engagements"
                  items={service.engagements}
                />
              </Col>
            </Row>
          </Container>
        </section>

        <Contact
          key={service.slug}
          id="service-contact"
          eyebrow={service.isCampaign ? "SAP BTP Support" : "Service Enquiry"}
          title={service.contact.title}
          description={service.contact.description}
          enquiry={service.contact.enquiry}
          messagePlaceholder={service.contact.messagePlaceholder}
          submitLabel={service.contact.submitLabel}
          showContactCards={false}
        />
      </main>
      <Footer />
      <FooterAlt />
      <BackToTop />
    </React.Fragment>
  );
};

export default ServiceDetail;
